module.exports = __webpack_public_path__ + "media/images/application/template/logos/tyrefix-5afdcd47674580f1ad67d5900c723c66.png";